import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';

import { CenterlinkService } from "../shared/centerlink.service";
import { CustomerService } from "../shared/customer.service";

@Component({
  selector: 'app-centerlink',
  templateUrl: './centerlink.component.html',
  styleUrls: ['./centerlink.component.css']
})
export class CenterlinkComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  CentrelinkNo: number =0;

  EditingCustomerId: number =0;
  EditingAdmissionFee: number =50;
  EditingId: number =0;

  // list: any[] = [];
  CentreList: any[] = [];
  CustomerList: any[] = [];
  MemberGroupList: any[] = [];

  LeaderName: string;
  MeetingDay: string;
  CurrentFlagStatus : number;

  constructor(public centerlinkService: CenterlinkService,
              private customerService: CustomerService,
              private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.CentrelinkNo = +  params['Id']; // (+) converts string 'id' to a number
    });
  
    this.GetCentreList();
    this.GetCustomerList();   
    this.resetForm();

    if (Number.isNaN(this.CentrelinkNo)) {
      this.centerlinkService.selectedCenterlink.Id = 0;
      this.centerlinkService.selectedCenterlink.Flag = 1;
      this.CurrentFlagStatus = 1;
      this.centerlinkService.selectedCenterlink.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.centerlinkService.selectedCenterlink.Id = +this.CentrelinkNo;
      this.centerlinkService.selectedCenterlink.Flag = 2;
      this.CurrentFlagStatus = 2;
      this.centerlinkService.selectedCenterlink.IsActive = true;
      this.AddButtonText = "Edit & Save";

      this.GetCentreLinkById()
    }  
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.centerlinkService.selectedCenterlink = {

      Id: 0,
      CentreId: 0,
      GroupId: 0,
      CustomerId: 0,
      LeaderId: null,
      LeaderName: null,
      MeetingDay: null,
      AdmissionFee: 50.00,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: true,
      Flag: 1,

      BranchId:0,
    }
  }

  GetCentreList() {
    this.centerlinkService.GetCentreList()
    .toPromise()
    .then(data => {
      this.centerlinkService.selectedCenterlinkList = data;
      this.CentreList = data;

      // console.log(data);
    })
  }

  GetMemberGroupList(id: any) {
    this.centerlinkService.GetMemberGroupList(id)
    .toPromise()
    .then(data => {
      this.MemberGroupList = data;
      this.centerlinkService.selectedCenterlink.GroupId =data[0].Id;
    })
  }

  GetCustomerList() {
    this.customerService.FetchCustomerList()
    .toPromise()
    .then(data => {
      this.CustomerList = data;
    })
  }

  selectChange(centreId: any):void {
    this.GetMemberGroupList(centreId);
    this.CentreDetailsByCentreId(centreId); // for display Leader Name & Meeting Day

    // console.log( this.LoadingTimeCustomerId);
    this.centerlinkService.selectedCenterlink.CustomerId = this.EditingCustomerId;
    this.centerlinkService.selectedCenterlink.AdmissionFee = this.EditingAdmissionFee;
    this.centerlinkService.selectedCenterlink.Id = this.EditingId;
    this.centerlinkService.selectedCenterlink.IsActive = true ;
    
  }

  CentreDetailsByCentreId(centreId: number) :void{

    // this.centerlinkService.GetCentreLinkById(centreId).subscribe(data => {
    //   this.centerlinkService.searchedCenterlinkList = data;
    // });
    // console.log( this.centerlinkService.selectedCenterlinkList);
    this.centerlinkService.searchedCenterlinkList = this.centerlinkService.selectedCenterlinkList.filter(item => item.Id == centreId);    
    
    // console.log(centreId);
    // console.log(this.centerlinkService.searchedCenterlinkList );
    // this.centerlinkService.selectedCenterlinkList.filter(item => item.Id === centreId)
    // .forEach(val => this.centerlinkService.searchedCenterlinkList
    // .push(Object.assign({}, val)));
    // console.log( this.centerlinkService.searchedCenterlinkList);
  //  console.log( this.centerlinkService.searchedCenterlinkList[0].LeaderName);
    
    this.LeaderName = this.centerlinkService.searchedCenterlinkList[0].LeaderName;
    // this.MeetingDay =  this.centerlinkService.searchedCenterlinkList[0].MeetingDay;
    this.centerlinkService.selectedCenterlink.IsActive =  this.centerlinkService.searchedCenterlinkList[0].IsActive;
    this.centerlinkService.selectedCenterlink.Flag =+ this.CurrentFlagStatus ;
    this.centerlinkService.selectedCenterlink.MeetingDay =  this.centerlinkService.searchedCenterlinkList[0].MeetingDay;
    this.centerlinkService.selectedCenterlink.AdmissionFee = this.EditingAdmissionFee;
  }

  GetCentreLinkById(): void{
    this.centerlinkService.GetCentreLinkById(this.CentrelinkNo)
    .toPromise()
    .then(data => {
     this.centerlinkService.selectedCenterlink = data;
    
     this.centerlinkService.selectedCenterlink.Id = data.Id;
     this.centerlinkService.selectedCenterlink.GroupId = data.GroupId;
     this.centerlinkService.selectedCenterlink.AdmissionFee = data.AdmissionFee; 
     this.centerlinkService.selectedCenterlink.CustomerId = data.CustomerId; 

     this.EditingCustomerId = data.CustomerId;
     this.EditingAdmissionFee = data.AdmissionFee;
     this.EditingId = data.Id;
     
     console.log(data.CentreId)
     this.selectChange(data.CentreId) ;
     return;
    })
  }

  public onSubmit(form: NgForm) {

    // console.log(form.value);
    if (this.centerlinkService.selectedCenterlink.CustomerId != 0) {
      this.centerlinkService.IUDCentreLink(form.value)
        .toPromise()
        .then(data => {
          this.resetForm(form);
          this.router.navigate(['/centrelinklist']);
        })
    }
  }
}
